var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineSearchSetting(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_outline_x2F_search-setting_00000179628817141607033610000004995335784943578808_"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M24,0L24,0v24H0V0H24z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_x2F_outline_x2F_search-setting"
  }, /*#__PURE__*/React.createElement("g", {
    id: "search-setting"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M1.2,11c0-5.4,4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8s-4.4,9.8-9.8,9.8S1.2,16.4,1.2,11z M2.8,11 c0,4.6,3.7,8.2,8.2,8.2s8.2-3.7,8.2-8.2S15.6,2.8,11,2.8S2.8,6.4,2.8,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000133492345278758298570000011151156027392454299_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M8.7,11c0-1.3,1-2.3,2.3-2.3 s2.3,1.1,2.3,2.3c0,1.3-1.1,2.3-2.3,2.3S8.7,12.3,8.7,11z M10.2,11c0,0.5,0.4,0.8,0.8,0.8s0.8-0.4,0.8-0.8c0-0.5-0.4-0.8-0.8-0.8 S10.2,10.5,10.2,11z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000165210643461723221530000006339602054094776765_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M11.3,15.9l-0.1-0.1 c-0.1-0.2-0.2-0.2-0.2-0.2c0,0-0.1,0.1-0.2,0.2l-0.1,0.1c-0.5,0.8-1.5,1.1-2.2,0.6L7.6,16c-0.4-0.2-0.7-0.6-0.8-1.1 c-0.1-0.4-0.1-0.9,0.2-1.3C7,13.4,7,13.3,7,13.3c0,0-0.1-0.1-0.3-0.1c-1,0-1.8-0.8-1.8-1.8v-0.9c0-1,0.8-1.8,1.8-1.8 C6.9,8.8,7,8.7,7,8.7c0,0,0-0.1-0.1-0.3C6.7,8,6.6,7.5,6.7,7.1C6.9,6.6,7.2,6.2,7.6,6l0.9-0.5c0.8-0.4,1.8-0.2,2.2,0.6l0.1,0.1 C10.9,6.4,11,6.4,11,6.4c0,0,0.1-0.1,0.2-0.3l0.1-0.1c0.5-0.8,1.5-1,2.2-0.6L14.4,6c0.4,0.2,0.7,0.6,0.8,1.1 c0.1,0.5,0.1,0.9-0.2,1.3C15,8.6,15,8.7,15,8.7c0,0,0.1,0.1,0.3,0.1c1,0,1.8,0.8,1.8,1.8v0.9c0,1-0.8,1.8-1.8,1.8 c-0.2,0-0.3,0.1-0.3,0.1c0,0,0,0.1,0.1,0.3c0.2,0.4,0.3,0.9,0.2,1.3c-0.1,0.5-0.4,0.8-0.8,1.1l-0.9,0.5c-0.3,0.2-0.5,0.2-0.8,0.2 C12.1,16.7,11.6,16.5,11.3,15.9z M12.5,15.1l0.1,0.1c0,0.1,0.1,0.1,0.2,0l0.9-0.5c0.1,0,0.1-0.1,0.1-0.2s0-0.1,0-0.2 c-0.4-0.6-0.4-1.3-0.1-1.8c0.3-0.5,0.9-0.8,1.6-0.8c0.1,0,0.3-0.1,0.3-0.2v-0.9c0-0.1-0.1-0.2-0.2-0.2c-0.7,0-1.3-0.3-1.6-0.8 c-0.3-0.5-0.3-1.2,0.1-1.8c0.1-0.1,0-0.2,0-0.2c0,0,0-0.1-0.1-0.2l-0.9-0.5c-0.1,0-0.1,0-0.2,0.1l-0.1,0.1c-0.4,0.6-0.9,1-1.5,1 c-0.6,0-1.2-0.4-1.5-1L9.4,6.8c0-0.1-0.1-0.1-0.2,0L8.3,7.3c-0.1,0-0.1,0.1-0.1,0.2c0,0,0,0.1,0,0.2c0.4,0.6,0.4,1.3,0.1,1.8 C8,10,7.5,10.3,6.7,10.3c-0.1,0-0.3,0.1-0.3,0.2v0.9c0,0.1,0.1,0.2,0.2,0.2c0.7,0,1.3,0.3,1.6,0.8c0.3,0.5,0.3,1.2-0.1,1.8 c0,0.1,0,0.1,0,0.2s0,0.1,0.1,0.2l0.9,0.5c0.1,0,0.1,0,0.2,0l0.1-0.1c0.4-0.6,0.9-1,1.5-1S12.2,14.4,12.5,15.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000044889545287873938640000010496567431944768651_",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "{props.color}",
    d: "M19.9,22.8c-0.5-0.1-1.3-0.4-1.8-1.8 c-0.2-0.8-0.2-1.5,0.2-2.1s1.1-0.9,1.9-0.9c1,0,1.8,0.4,2.2,1.1s0.3,1.6-0.3,2.4c-0.7,1.1-1.5,1.3-2,1.3 C20.1,22.8,20,22.8,19.9,22.8z M20.1,21.3c0.2,0,0.5-0.2,0.8-0.6c0.3-0.4,0.3-0.7,0.2-0.9c-0.1-0.1-0.4-0.3-0.9-0.3 c-0.3,0-0.5,0.1-0.7,0.3c-0.1,0.2-0.1,0.4,0,0.7C19.7,21,20,21.3,20.1,21.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_00000155139329537693508510000002124905821732432815_",
    fill: "none",
    d: "M24,0v24H0V0H24z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSearchSetting);
export default __webpack_public_path__ + "static/media/vuesax-outline-search-setting.c064014e615cd08d409fceb84c95e6ce.svg";
export { ForwardRef as ReactComponent };